/* eslint-disable react-hooks/exhaustive-deps */
import { CreateActionsDropdown } from './CreateActionsDropdown';
import { WorkoutsTabs } from './WorkoutsTabs';
import { TitledPage } from '@client/new/components/Misc';
import { useEffect, useState } from 'react';
import { FlowEducationalModal } from '@client/new/common/onboardingFlow/FlowEducationalModal';
import { Influencer } from '@playbook-technologies/common-enums';
import { useLocalStorage } from '@client/hooks/use-local-storage';

export function WorkoutsPage({ isLoading, creator, children }) {
  const title = 'Workouts';
  const [showEducation, setShowEducation] = useState(false);
  const [visited, setVisited] = useLocalStorage(
    'workoutsEducationModal',
    false,
  );

  useEffect(() => {
    if (creator.mode === Influencer.Mode.Onboarding.value && !visited) {
      setShowEducation(true);
      setVisited(true);
    }
  }, [creator, visited]);

  return (
    <TitledPage
      title={title}
      rightContent={
        <CreateActionsDropdown
          influencerId={creator.id}
          selectedProgramId={null}
        />
      }
    >
      <div>
        <WorkoutsTabs creatorId={creator.id} />
        {isLoading && <div>Loading...</div>}
        {!isLoading && <div className="newWorkoutList">{children}</div>}
        <FlowEducationalModal
          isOpen={showEducation}
          onClose={() => setShowEducation(false)}
          source="workout"
          influencerId={creator.id}
        />
      </div>
    </TitledPage>
  );
}
